import React, { Component } from "react";

// React router
import { withRouter } from "react-router-dom";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Dependencies
import _ from "lodash";
import PropTypes from "prop-types";

// Material ui
import { withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

// Shared layouts
import { Dashboard as DashboardLayout } from "layouts";
import Chat from "../../layouts/Dashboard/components/Chat";

// Assistant page specific styles
import "./assistant.css";

import { welcomeMessageSent as welcomeMessageSentFunction } from "../../redux/actions/chatActions";
class AssistantPage extends Component {
  render() {
    return (
      <DashboardLayout title="Bubbles" removeChat={true}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Chat assistantPage={true} />
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    welcomeMessageSent: _.get(state, "chat.welcomeMessageSent", true)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        welcomeMessageSentFunction
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssistantPage)
);
